<template>
	<div :class="environmentClass">
		<router-view></router-view>
	</div>
</template>

<script>
import Vue from "vue";
import models from "./routes/models.js";
import radiosByUser from "./utils/events/radios-by-user.js";
import Swal from "sweetalert2";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import jwt_decode from "jwt-decode";
const firebaseConfig = {
	apiKey: "AIzaSyA5I8hEFZsrzxjXdOmBgP3K_E_TnX2TKiY",
	authDomain: "api-mobradio.firebaseapp.com",
	databaseURL: "https://api-mobradio.firebaseio.com",
	projectId: "api-mobradio",
	storageBucket: "api-mobradio.appspot.com",
	messagingSenderId: "1050850795324",
	appId: "1:1050850795324:web:b37961a293763084764839",
	measurementId: "G-PPDLLJMYCJ",
};

firebase.initializeApp(firebaseConfig);
export default {
	data() {
		return {
			userId: "",
		};
	},
	computed: {
		environmentClass() {
			const env = process.env.NODE_ENV;
			// Retorna classe 'non-production' para qualquer ambiente que não seja produção
			if (env !== "production") {
				return "non-production-environment";
			}
			return "";
		},
	},
	methods: {
		getUserId() {
			const user = jwt_decode(localStorage.getItem("SET_APP")).user[0];
			if (user) {
				Promise.resolve(this.getRadiosByUserId(user.id))
					.then((resp) => {
						radiosByUser.$emit("Radios", resp.data);
					})
					.catch((e) => {
						console.log(e);
					});
			} else {
				// this.$router.push('login')
			}
		},
		async getRadiosByUserId(id) {
			return await models().get(`users/getRadiosByUserId?userId=${id}`);
		},
	},
	mounted() {
		let vm = this;
		window.setInterval(
			function (param) {
				if (
					vm.$route.path !== "/" &&
					vm.$route.path !== "/login" &&
					vm.$route.path !== "/pricing" &&
					vm.$route.path !== "/forms/wizard"
				) {
					const user = jwt_decode(localStorage.getItem("SET_APP")).user[0];
					if (!user) {
						Swal(
							"Atenção",
							"Sua sessão expirou, por favor faça login novamente.",
							"warning"
						);
						sessionStorage.clear();
						localStorage.clear();
						vm.$router.push("login");
					} else {
						const unix_timestamp = jwt_decode(
							localStorage.getItem("SET_APP")
						).exp;
						const session = new Date(unix_timestamp * 1000);
						const now = new Date();
						if (now > session) {
							Swal(
								"Atenção",
								"Sua sessão expirou, por favor faça login novamente.",
								"warning"
							);
							sessionStorage.clear();
							localStorage.clear();
							vm.$router.push("login");
						}

						// var dt1 = new Date(user.timestamp)
						// var dt2 = new Date()
						// var diff =(dt2.getTime() - dt1.getTime()) / 1000;
						// diff /= 60;
						// if(Math.abs(Math.round(diff)) > 240) {
						//     Swal(
						//         'Atenção',
						//         'Sua sessão expirou, por favor faça login novamente.',
						//         'warning'
						//     )
						//     sessionStorage.clear()
						//     localStorage.clear()
						//     vm.$router.push('login')
						// }
					}
				}
			}.bind(),
			2000
		);

		this.getUserId();
	},
};
</script>

<style>
@import url("//unpkg.com/element-ui@2.4.6/lib/theme-chalk/index.css");
.mx-icon-last-year,
.mx-icon-last-month,
.mx-icon-next-year,
.mx-icon-next-month,
.mx-current-month,
.mx-current-year {
	color: #000 !important;
}
.display-center-container {
	display: flex;
}
.display-center-child {
	align-items: center;
}
.el-input__inner,
.el-textarea__inner {
	margin-top: 15px;
}
.dt-gifts {
	margin-top: 15px;
}
.md-datepicker-overlay,
.md-datepicker-dialog {
	z-index: 999999 !important;
}
.md-table-head-label {
	width: 100%;
}
i.md-icon.md-icon-font.md-icon-image.md-table-sortable-icon.md-theme-default {
	left: 35%;
}
.sidebar-wrapper {
	overflow-x: hidden !important;
}
.sidebar-wrapper::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
	background-color: #f5f5f5;
}
.sidebar-wrapper::-webkit-scrollbar {
	width: 10px;
	background-color: #f5f5f5;
}

.sidebar-wrapper::-webkit-scrollbar-thumb {
	/* border-radius: 10px; */
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
	background-color: #555;
}
@media (max-width: 900px) {
	.el-dialog {
		width: 90vw;
	}
	.mx-input-wrapper {
		margin-top: 10px;
		margin-bottom: 10px;
	}
	i.md-icon.md-icon-font.md-icon-image.md-table-sortable-icon.md-theme-default {
		left: 70%;
	}
}
@media (min-width: 900px) {
	.md-datepicker-overlay,
	.md-datepicker-dialog {
		max-height: 350px !important;
	}
}

@page {
	size: auto;
}

@media print {
	tr {
		page-break-inside: avoid;
	}
	table.report-container {
		page-break-after: always !important;
	}
	thead.report-header {
		display: table-header-group !important;
	}
	tfoot.report-footer {
		display: table-footer-group !important;
		text-align: center;
		font-size: 12pt;
	}
}

/* Indicador visual de ambiente não-produção - altera cores azuis para vermelho */
.non-production-environment {
	/* Cor vermelha para substituir o azul (#009ddb) */
	--non-prod-primary-color: #e53935; /* Vermelho similar ao azul usado */
}

/* Logo do sidebar - muda de azul para vermelho */
.non-production-environment .sidebar .logo,
.non-production-environment .sidebar .logo-img {
	background-color: var(--non-prod-primary-color) !important;
}

/* Item ativo do menu sidebar - muda de azul para vermelho */
.non-production-environment
	.sidebar[data-color="azure"]
	.nav
	li.active
	> a:not([data-toggle="collapse"]) {
	background-color: var(--non-prod-primary-color) !important;
	box-shadow: 0 4px 20px 0 rgba(229, 57, 53, 0.14),
		0 7px 10px -5px rgba(229, 57, 53, 0.4) !important;
}

.non-production-environment
	.sidebar[data-color="azure"]
	.nav
	li.active
	> a:not([data-toggle="collapse"])
	.md-icon,
.non-production-environment
	.sidebar[data-color="azure"]
	.nav
	li.active
	> a:not([data-toggle="collapse"])
	i {
	color: rgba(255, 255, 255, 0.8) !important;
	opacity: 1 !important;
}

/* Navbar/Topbar - se tiver elementos azuis */
.non-production-environment .navbar .navbar-nav .nav-link:hover,
.non-production-environment .navbar .navbar-nav .nav-link:focus {
	color: var(--non-prod-primary-color) !important;
}

/* Botões e elementos com cor azul padrão */
.non-production-environment .btn-info,
.non-production-environment .btn-info:hover,
.non-production-environment .btn-info:focus,
.non-production-environment .btn-info:active {
	background-color: var(--non-prod-primary-color) !important;
	border-color: var(--non-prod-primary-color) !important;
}

/* Links azuis em elementos inline style */
.non-production-environment a[style*="#009ddb"],
.non-production-environment [style*="color: #009ddb"] {
	color: var(--non-prod-primary-color) !important;
}

/* Bordas azuis em elementos inline style */
.non-production-environment [style*="border.*#009ddb"],
.non-production-environment [style*="border-color: #009ddb"] {
	border-color: var(--non-prod-primary-color) !important;
}

/* Elementos com classe azure ou que usam brand-info */
.non-production-environment .event-azure,
.non-production-environment .ct-azure {
	background-color: var(--non-prod-primary-color) !important;
	stroke: var(--non-prod-primary-color) !important;
}
</style>
